//@ts-nocheck
import React, {useEffect, useState} from "react";
import { ApexOptions } from 'apexcharts';
import ReactApexChart from "react-apexcharts";
import '../../i18/config';
import {useTranslation} from "react-i18next";

import {StatPeerChannelDataType} from "../../redux/Stat/PeerChannel/types";
import {ChartTypes} from "../../data/chartTypes";
import {convertToMomentLocale} from "../../helpers/functions";
import {format} from "date-fns";
import {alignDailySeries, baseMetric, changeKeys} from "../../helpers/statSeries";

interface InputProps {
    items: [] | Array<StatPeerChannelDataType>;
    chartType: string;
    group?: string;
    id?: string;
}

const ChannelActivitiesChartItem = ({ items, chartType, group, id }: InputProps) => {
    const { t, i18n } = useTranslation();

    const [ seriesLabels, setSeriesLabels ] = useState<any[]>([]);
    const [ series, setSeries ] = useState<any[]>([]);

    // The plain keys are running totals: the chart shows each day's change
    // (`<metric>Change`), aligned by date — a day without a value is a gap, not a zero.
    const generateSeries = (items: StatPeerChannelDataType[]) => {
        const aligned = alignDailySeries(items, changeKeys(items));
        return {
            labels: aligned.labels,
            series: aligned.series.map(serie => ({name: t('stat:' + baseMetric(serie.key)), data: serie.data})),
        };
    };

    useEffect(() => {
        const generated = generateSeries(items);
        setSeriesLabels(generated.labels);
        setSeries(generated.series);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t, items, chartType]);

    let options : ApexOptions = {
        chart: {
//            id: id ? id : undefined,
            height: 374,
            type: 'line',
            group: group ? group : undefined,
            toolbar: {
                show: false,
            }
        },
        stroke: chartType === ChartTypes.LINE ? { curve: 'smooth', width: 3 } : {},
        fill: {
             opacity: 1
        },
        // markers: {
        //   size: 3,
        //     strokeWidth: 2,
        //     hover: {
        //         size: 4,
        //     }
        // },
        xaxis: {
            categories: seriesLabels,
            axisTicks: {
                show: false
            },
            axisBorder: {
                show: false
            },
            labels: {
                formatter: function (value) {
                    return format(new Date(value),'dd MMM yyyy', {locale: convertToMomentLocale(i18n.language)});
                }
            }
        },
        grid: {
            show: true,
            xaxis: {
                lines: {
                    show: true,
                }
            },
            yaxis: {
                lines: {
                    show: false,
                }
            },
            padding: {
                top: 0,
                right: -2,
                bottom: 15,
                left: 10
            },
        },
        legend: {
            show: true,
            horizontalAlign: 'center',
            offsetX: 0,
            offsetY: -5,
            markers: {
                width: 9,
                height: 9,
                radius: 6,
            },
            itemMargin: {
                horizontal: 10,
                vertical: 0
            },
        },
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                horizontal: false,
                barHeight: '80%',
                rangeBarOverlap: false,

                columnWidth: '80%',
            }
        },
    };

    if (series.length === 0) {
        return <div className="text-muted text-center py-5" data-testid="channel-activities-no-data">{t('stat:noDataYet')}</div>;
    }

    return(
        <>
                    <ReactApexChart
                        key={'channelActivitiesChart_'+chartType}
                        options={options}
                        series={series}
                        type={chartType}
                        height="436"
                        className="apex-charts"
                    />
        </>
    );
}

export default ChannelActivitiesChartItem;